import { ActionType, createReducer } from "typesafe-actions";
import { resetApiError } from "store/features/general";
import * as actions from "./ad.actions";
import { Ad } from "./interfaces";

const { fetchAd } = actions;

export type AdAction = ActionType<typeof actions>;

export type AdState = Readonly<{
    hasError: boolean;
    isProcessing: boolean;
    materialSpecificationId?: number;
    ad: Ad;
}>;

export const adState: AdState = {
    hasError: false,
    isProcessing: false,
    ad: {
        orderNumber: "",
        dueDate: "",
        salesRep: {
            name: "",
            email: "",
            phone: "",
        },
        customer: {
            id: null,
            name: "",
        },
    },
};

// todo: combine ad reducer with creativeUpload reducer after refactoring and changing creativeUpload to campaign
export const adReducer = createReducer<AdState, AdAction>(adState)
    .handleAction(fetchAd.request, (state) => {
        return {
            ...state,
            isProcessing: true,
        };
    })
    .handleAction(fetchAd.success, (state, { payload }) => {
        return {
            ...state,
            isProcessing: false,
            ad: payload,
        };
    })
    .handleAction(fetchAd.failure, (state) => {
        return {
            ...state,
            isProcessing: false,
            hasError: true,
        };
    })
    .handleAction(resetApiError as never, (state) => {
        return {
            ...state,
            hasError: false,
        };
    });
